import type { SystemStyleObject } from "@chakra-ui/react";

export const lrnCommonStylings: SystemStyleObject = {
  "& *": {
    textStyle: "body.large",
    color: "text"
  },
  "&& .lrn_possibilityList": {
    backgroundColor: "canvas !important"
  },
  "& .lrn .lrn_possibilityList": {
    border: "none"
  },
  "& .lrn_response_input_wrapper": {
    border: "none"
  },

  "& .lrn_classification, & .lrn_association, & .lrn_clozeassociation": {
    "& .lrn_btn_drag.lrn_draggable": {
      display: "inline-flex",
      alignItems: "center",
    },

    "& .lrn_response": {
      "& .lrn_dropzone": {
        borderRadius: 6,
        border: 2,
        borderStyle: "solid",
        borderColor: "lines"
      }
    },

    "& .lrn_possibilityList.lrn_list_bottom": {
      background: "unset",
      border: 2,
      borderStyle: "solid",
      borderColor: "lines",
      borderRadius: "md",
    },

    "& .lrn_dragdrop:not(.lrn_disabled).lrn_dropzone.lrn_highlight": {
      borderColor: "button.bg.filled"
    },
  },

  "& .lrn_btn_drag.lrn_draggable": {
    "& span.lrn_item, & span.lrn_item *": {
      color: "base.700 !important",
    },
  }
};

export const lrnCorrectIcon: SystemStyleObject = {
  backgroundImage:
    "url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='12' cy='12' r='12' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.868-14.88a.876.876 0 0 0 0-1.238h.003a.876.876 0 0 0-1.239 0l-6.382 6.38-2.882-2.88a.876.876 0 0 0-1.239 1.239l3.5 3.5a.876.876 0 0 0 1.24 0l7-7z' fill='%238CA95E'/%3E%3C/svg%3E%0A\")",
};

export const lrnIncorrectIcon: SystemStyleObject = {
  backgroundImage:
    "url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='12' cy='12' r='12' fill='white'/%3E%3Cpath d='M12 0a12 12 0 1 1 0 24 12 12 0 0 1 0-24zM8.203 15.797c.44.44 1.153.44 1.59 0l2.202-2.203 2.203 2.203a1.125 1.125 0 0 0 1.59-1.59l-2.204-2.202 2.204-2.203a1.125 1.125 0 0 0-1.59-1.59l-2.203 2.204-2.203-2.204a1.125 1.125 0 0 0-1.59 1.59l2.204 2.203-2.203 2.203a1.12 1.12 0 0 0 0 1.589z' fill='%23F16063'/%3E%3C/svg%3E%0A\")",
};
